export enum CustomerOriginEnum {
  LOJA = 1,
  DELIVERY = 2,
  SITE = 3,
  SOCIAL_NETWORK = 4,
}
